// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";

export default {
  /**
   * Gets the permissions of the connected user
   * @returns {Array<object>} List of UserPermission
   */
  getUserPermissions() {
    return backend.get("/permissions");
  },
};
